import withBookstoreService from "./with-bookstore-service";



export default withBookstoreService;